// Slim v1 event taxonomy - mirrors Tuna.RF.API's src/lib/constants/logs.constants.ts
// so the two sides read as one timeline in Loki.
export const LOG_EVENTS = {
  JOURNEY_START: "JOURNEY.START",
  JOURNEY_CLIENT_REDIRECT: "JOURNEY.CLIENT_REDIRECT",
  JOURNEY_END: "JOURNEY.END",

  /* ---------------- LANDING (Init.jsx / Campaign.jsx entry) ---------------- */
  LANDING_INIT: "UI.LANDING.INIT",
  LANDING_REQUEST_SENT: "UI.LANDING.REQUEST_SENT",
  LANDING_RESPONSE_RECEIVED: "UI.LANDING.RESPONSE_RECEIVED",
  LANDING_REQUEST_ERROR: "UI.LANDING.REQUEST_ERROR",
  LANDING_REDIRECT_TO_PROFILER: "UI.LANDING.REDIRECT_TO_PROFILER",
  LANDING_REDIRECT_TO_SUPPLIER: "UI.LANDING.REDIRECT_TO_SUPPLIER",

  /* ---------------- PROFILING (/p questions) ---------------- */
  PROFILING_QUESTION_REQUEST: "UI.PROFILING.QUESTION_REQUEST",
  PROFILING_QUESTION_RECEIVED: "UI.PROFILING.QUESTION_RECEIVED",
  PROFILING_ANSWER_SENT: "UI.PROFILING.ANSWER_SENT",
  PROFILING_ANSWER_SAVED: "UI.PROFILING.ANSWER_SAVED",
  PROFILING_ERROR: "UI.PROFILING.ERROR",

  /* ---------------- SURVEY (dynamic profiling / routing, /st) ---------------- */
  SURVEY_QUESTION_REQUEST: "UI.SURVEY.QUESTION_REQUEST",
  SURVEY_QUESTION_RECEIVED: "UI.SURVEY.QUESTION_RECEIVED",
  SURVEY_ANSWER_SENT: "UI.SURVEY.ANSWER_SENT",
  SURVEY_REDIRECT_TO_CLIENT: "UI.SURVEY.REDIRECT_TO_CLIENT",
  SURVEY_REDIRECT_TO_SUPPLIER: "UI.SURVEY.REDIRECT_TO_SUPPLIER",
  SURVEY_ERROR: "UI.SURVEY.ERROR",

  /* ---------------- ENDING (/e, /redirect/:status) ---------------- */
  ENDING_RECEIVED: "UI.ENDING.RECEIVED",
  ENDING_REDIRECT_TO_SUPPLIER: "UI.ENDING.REDIRECT_TO_SUPPLIER",
  ENDING_REDIRECT_TO_START: "UI.ENDING.REDIRECT_TO_START",
  ENDING_ERROR: "UI.ENDING.ERROR",
};

// Log level is derived server-side from the event name (see the API's
// getLogLevel) so both sides can't drift out of sync on level casing/rules.
